import { ReactNode } from 'react';

import { IndicatorsDisplay } from '../../../core/components/annotations/components/indicators/types.js';

/**
 * The Marker slot component for XYChart Annotations
 * @public
 */
export interface XYChartAnnotationsMarkerProps {
  /** Indicates what data field from the data object should be used as the start point for the markers */
  startAccessor: string;
  /** Indicates what data field from the data object should be used as the end point of the markers */
  endAccessor: string;
  /** Indicates what data field from the data object should be used to link this marker to a track. It must contain the unique id of a track. */
  trackByAccessor: string;
  /** Indicates what data field from the data object should be used as the description of each marker */
  descriptionAccessor?: string;
  /** Indicates what data field from the data object should be used as the color of each marker
   *  @defaultValue Colors.Charts.Categorical.Color01.Default
   */
  colorAccessor?: string;
  /** Indicates what data field from the data object should be used as the title of each marker */
  titleAccessor?: string;
  /** letter/emoji/icon/glyph or Unicode character */
  symbol?: ReactNode | ((t: unknown) => ReactNode);
  /** Defines the display behaviour of marker's indicators of a particular track */
  indicatorsDisplay?: IndicatorsDisplay | ((t: unknown) => IndicatorsDisplay);
  /** Flag to hide a marker */
  hidden?: boolean | ((t: unknown) => boolean);
  /** Priority of annotation in case of overlapping. The higher the number, the higher priority */
  priority?: number | ((t: unknown) => number);
}

export const Marker = (props: XYChartAnnotationsMarkerProps) => null;

Marker['displayName'] = 'XYChartAnnotations.Marker';
